<template>
  <div class="report-container" v-if="isResult">
    <div class="bg-logo">
      <span class="logo_text">该鉴别报告由图灵鉴定小程序提供</span>
    </div>
    <div class="flex-body">
      <div class="info_content">
        <div class="report-header">
          <img src="https://oss.turingsenseai.com/1755246161445660048.jpg" class="logo">
          <span class="title" @click="getReport()">图灵鉴定高拍仪</span>
        </div>
        <div class="brief-info">
          <div class="left">
            <div class="info_desc_line">
              <div class="desc_label">鉴别结果</div>
              <div class="desc_content">{{ RESULT_MAP[detail.manualResult || detail.aiResult] }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">鉴别时间</div>
              <div class="desc_content">{{ detail.appraisalTime }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">品类</div>
              <div class="desc_content">{{ detail.kindName }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">品牌</div>
              <div class="desc_content">{{ detail.brandName || "-" }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">系列</div>
              <div class="desc_content">{{ detail.seriesName || "-" }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">鉴别编号</div>
              <div class="desc_content">{{ detail.oaId }}</div>
            </div>
            <div class="info_desc_line">
              <div class="desc_label">图灵货品码</div>
              <div class="desc_content">{{ $route.query.serialNum || "-" }}</div>
            </div>
          </div>
        </div>
        <div class="icon-line"></div>
      </div>
      <!-- 详情 -->
      <div class="detail_content">
        <!-- 滑动 -->
        <div class="tab-bar">
          <perfect-scrollbar>
            <div class="scroll-view">
              <div v-for="(t, i) in newSARecordList" :key="i" class="box">
                <div :class="{ item: true }">
                  <van-image :show-loading="false" :src="t.image" class="item" fit="contain"
                    @click="changeGrade(t, i)"></van-image>
                  <div :class="{ tag: true, 'tag-active': tabActive === i }">
                    {{ t.pointName }}
                  </div>
                  <van-image @click="(e) => showImage(e, i)" :show-loading="false" class="show-icon"
                    src="https://oss.turingsenseai.com/1650956009715204926.png"></van-image>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>

        <!-- 鉴定点分数详情 -->
        <div class="detail_grade">
          <Precent v-show="nowGrade" :grade="nowGrade"></Precent>
        </div>

      </div>
    </div>
    <div class="safe-bottom"></div>
  </div>
  <div class="no-result" v-else>
    <div class="empty">
      <img class="null-img" src="https://oss.turingsenseai.com/1722581182806982453.jpg">
      <span>当前订单人工复核尚未完成，请耐心等待~</span>
    </div>
  </div>
</template>

<script>
const SEAL = {
  real: 'https://oss.turingsenseai.com/1663065727982709745.png',
  fake: 'https://oss.turingsenseai.com/1666691981753319068.png',
  unknow: 'https://oss.turingsenseai.com/1628582036592914079.png'
}
const GENUINE_TYPE = {
  '0': {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984567078472945.jpg',
    typeBgClass: 'fake'
  },
  '1': {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984569383001375.jpg',
    typeBgClass: 'real'
  },
  '2': {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: 'fake'
  },
  '3': {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: '',
    code: 33
  },
  '4': {
    desp: '预计4-24小时内出结果，请耐心等待。',
  }
}

const AITOMANUAL_TYPE = {
  0: {
    desp: '预计4-24小时内出结果，请耐心等待。',
  },
  2: {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984567078472945.jpg',
    typeBgClass: 'fake'
  },
  1: {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984569383001375.jpg',
    typeBgClass: 'real'
  },
  3: {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: 'fake'
  },
  5: {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: '',
    code: 33
  },
}
import Precent from './components/precent.vue'
import { ImagePreview, Toast } from "vant";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { fetchAppraisalGpyReport } from "@/common/api/appraisal.js";

export default {
  components: {
    Precent,
  },
  props: {
    isManual: {
      type: Boolean,
      default: false
    },
    isPcFlag: {
      type: Boolean,
      default: false,
    },
    appid: {
      type: String,
      required: false,
      default: ""
    },
    brandName: {
      type: String,
      required: true,
      default: ""
    },
    OAID: {
      type: String,
      required: true,
      default: ""
    },
    sequence: {
      type: String,
      require: true,
      default: ""
    },
    SARecordList: {
      type: Array,
      required: true,
      default: []
    },
    aIToManualResult: {
      type: Number,
      default: () => {
        return 3
      }
    },
    genuine: {
      type: String,
      required: true,
      default: '1'
    },
    kindID: {
      type: Number,
      required: true,
    },
    brandID: {
      type: Number,
      required: true,
    },
    seriesID: {
      type: Number,
      required: true,
    },
    hierarchy: {
      type: String,
      required: true,
    },
    appraisalRemark: {
      type: String,
      required: false,
    },
    cardRatings: {
      type: Array,
      default: []
    },
    isToManualRealTimeOrder: {
      type: Boolean
    }
  },
  
  mounted () {
    // this.SARecordList.forEach((item, index) => {
    //   this.newSARecordList.push(item);
    //   // this.SARecordList.push(item);
    // });
    // while (this.newSARecordList.length <= 5) {
    //   this.newSARecordList.push({
    //     pointName: ''
    //   })
    // }
    // this.changeGrade(this.newSARecordList[0],0)
    this.getReport()
  },
  computed: {
    genuineType() {
      // console.log(GENUINE_TYPE, this)
      console.log(this.genuine, GENUINE_TYPE[this.genuine])
      let showResult = 0
      if(!this.isManual && this.isToManualRealTimeOrder) {
        showResult = this.aIToManualResult
        return AITOMANUAL_TYPE[showResult] || {}
      }else{
        showResult = this.genuine
        return GENUINE_TYPE[showResult] || {}
      }
    }
  },
  data() {
    return {
      showMore: false,
      seal: SEAL,
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      newSARecordList: [],
      detail: {},
      isResult: false,
      nowGrade: '',
      nowDescription: '',
      detailScroll: '',
      tabActive: 0,
      nowPointName: '【鉴定点】',
      RESULT_MAP: {
        1: "符合正品工艺",
        2: "不符合正品工艺",
        3: "无法鉴定",
      }
    }
  },
  methods: {
    getReport() {
      fetchAppraisalGpyReport({
        ...this.$route.query,
        oaId: this.$route.query.oaid || this.$route.query.oaId || ""
      })
      .then(res => {
        if (res.oaId) {
          this.detail = res;
          this.isResult = res.manualResult;
          this.newSARecordList = res.singleRecords
          this.changeGrade(res.singleRecords[this.tabActive], this.tabActive)
        }
      })
      .finally(() => {
        this.loading = false;
      })
    },
    patch(){
      let url;
      if (this.appid === 'wx2974d4d19e8294d4') {
        // 验货宝小程序
        url = `/subPackages/personal/complementGraph/index?oaId=${this.OAID}`
      } else {
        // 兜底 - 一般指的是主站小程序
        if(this.isManual){
          url = `/subPackages/ai/identify/butu/index?oaId=${this.OAID}&guaqian=1`
        }else{
          url = `/subPackages/ai/identify/aiButu/index?oaId=${this.OAID}&key=${[this.kindID, this.brandID, this.seriesID][this.hierarchy]}&guaqian=1`
        }
      }

      if(window.__wxjs_environment === 'miniprogram'){
        wx.miniProgram.redirectTo({
          url,
          success: (res) => {
            console.log(res); // 页面跳转成功
          },
          fail: (err) => {
            console.log(err); // 页面跳转失败
          },
        });
      }else{
        Toast('请前往微信小程序 “我的-我的鉴别挂签” 找到订单，并完成补图操作~');
      }

    },
    showImage(e, index = 0) {
      e.preventDefault();
      e.stopPropagation();
      let images = this.newSARecordList.map((v) => v.image);
      ImagePreview({
        images,
        startPosition: index,
      });
    },
    changeGrade(detailData, i) {
      console.log(detailData,"--------------")
      this.nowDescription = detailData.description
      // 改成一分制
      this.nowGrade = (Number(detailData.grade) > 1 ? (Number(detailData.grade)/100).toFixed(2) : Number(detailData.grade))+''
      this.nowPointName = `【${detailData.pointName}】`
      this.tabActive = i
    },
    onCopy() {
      Toast('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_content {
  background-color: #fff;
  border-radius: 2 * 2px;
  .tab-bar {
    width: 307*2px;
    margin: 0 auto;
    ::v-deep .ps__rail-x {
      height: 0;
      opacity: 0;
      .ps__thumb-x {
        height: 0;
      }
    }
    .scroll-view {
      display: flex;
      height: 94 * 2px;
      // justify-content: flex-start;
      // align-items: flex-start;
      margin-top: 18 * 2px;
      .box {
        background: #35424d;
        margin-right: 20px;
        width: 180px;
        height: 180px;
        border-radius: 2px;
        .item {
          position: relative;
          display: inline-block;
          width: 180px;
          height: 180px;

          .show-icon {
            width: 30px;
            height: 30px;
            position: absolute;
            bottom: 10px;
            right: 10px;
          }

          .tag {
            top: 0px;
            left: 0 px;
            padding: 0 6px;
            height: 28px;
            z-index: 100;
            position: absolute;
            background-color: #efeff4;
            color: #828393;
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
          }
          .tag-active {
            background-color: #3b95ff;
            color: #fff;
          }
        }
        .item-active {
          border-radius: 2px;
          box-shadow: 0 0 0 4px #3a94ff;
        }
      }
    }
  }
  .detail_grade {
    width: 303 * 2px;
    margin: 0 auto;
    .point_dsc{
      margin-top: 20 * 2px;
      width: 303 * 2px;
      // height: 40 * 2px;
      background-color: #f8f8fb;
      font-size: 12 * 2px;
      font-weight: 500;
      p {
        display: inline-block;
        margin: 12 * 2px;
        margin-left: 8 * 2px;
        border-radius: 2 * 2px;
      }
    }
    .dsc_tip {
      display: inline-block;
      margin: 20 * 2px 0;
      font-size: 10 * 2px;
      color: #a8a8b3;
      text-align: center;
    }
  }
}


.report-container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  // padding: 0 12 * 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  // background: linear-gradient(270.23deg, #26262E 0.15%, #4D4D59 99.76%);
}
.bg-logo {
  height: 137 * 2px;
  width: 375 * 2px;
  // margin: 25 * 2px 0;
  // background: url('https://oss.turingsenseai.com/1628564754186096854.png') no-repeat;
  background: url('https://oss.turingsenseai.com/1662345030522135699.png') no-repeat;
  background-size: 100% 100%;
  .logo_text {
    display: flex;
    justify-content: center;
    padding-top: 15 * 2px;
    color: #fff;
    font-size: 12 * 2px;
  }
}
.flex-body {
  margin-top: -95 * 2px;
  width: 343 * 2px;
  position: relative;
  // display: flex;
  // flex-direction: column;
  align-items: center;
  overflow: hidden;
  // background-color: #FFF;
}

    .info_content {
      width: 343 * 2px;
      background-color: #fff;
      border-radius: 10 * 2px;
      margin-bottom: 10 * 2px;
      padding: 0 16 * 2px 0 16 * 2px;

      .report-header {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12 * 2px;
        padding: 40px 0;
        box-sizing: border-box;
        
        .logo{
          width: 50 * 2px;
          object-fit: contain;
          margin-right: 10 * 2px;
        }

        .title{
          color: #000;
          font-size: 30 * 2px;
        }
      }

      .brief-info {
        width: 100%;
        display: flex;
        align-items: center;
        .left {
          display: flex;
          flex-direction: column;
          flex: 1;
          .info_result {
            width: fit-content;
            margin-bottom: 29 * 2px;
            font-size: 24 * 2px;
            line-height: 34 * 2px;
            font-weight: 600;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            &.fake {
              background-size: 32 * 2px 32 * 2px;
              background-image: url("https://oss.turingsenseai.com/1628679595929512302.png");
            }
            &.real { // real
              background-size: 82px 60px;
              background-image: url("https://oss.turingsenseai.com/1628575456562452544.png");
            }
          }
          .info_desc_line {
            display: flex;
            flex-direction: column;
            margin-bottom: 15rpx;
          }
          .desc_label, .desc_content {
            font-size: 16 * 2px;
            line-height: 12* 2px;
            margin-bottom: 9 * 2px;
            &.has_cp_afterfix {
              position: relative;
              &::after {
                content: '复制';
                position: absolute;
                right: 0px;
                top: 0px;
                font-weight: 400;
                font-size: 12 * 2px;
                color: #999;
              }
            }
          }

          .desc_label {
            font-size: 12 * 2px;
            font-weight: 400;
            color: #828393;
          }
          .desc_content {
            color: #3a3d44;
            white-space: nowrap;
            font-weight: 500;
            margin-bottom: 20 * 2px;
            &.__wp {
              white-space: wrap;
              width: 280 * 2px;
              line-height: 1.2em;
              word-break: break-all;
            }
            .patch {
              font-weight: 400;
              font-size: 12 * 2px;
              margin-left: 20px;
              color: #3a94ff;
              text-decoration: underline;
            }
          }

          .score_container {
            position: absolute;
            top: 570px;
            display: flex;
            justify-content: flex-start;
            font-size: 12*2px;;
            .score_item {
              .title,.score {
                width: 60*2px;
                height: 24*2px;
                line-height: 24*2px;
                border-top: 1*2px solid #F0F0F5;
                border-right: 1*2px solid #F0F0F5;
                text-align: center;
              }
              .score {
                border-bottom: 1*2px solid #F0F0F5;
              }
            }
            .score_item:first-child {
              .title,.score {
                border-left: 1*2px solid #F0F0F5;
              }
            }
          }
        }
        .right {
          width: 135 * 2px;
          height: 126 * 2px;
          margin-left: 20 * 2px;
          margin-right: 8 * 2px;
          overflow: hidden;
          position: relative;
          top: 10 * 2px;
          right: 10 * 2px;
        }
      }
    }
.report-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12 * 2px;
  padding: 40px 0;
  box-sizing: border-box;
  
  .logo{
    width: 50 * 2px;
    object-fit: contain;
    margin-right: 10 * 2px;
  }

  .title{
    color: #000;
    font-size: 30 * 2px;
  }
}

.sub-bottom {
  margin-bottom: 0px !important;
  padding-bottom: 10px !important;
}

.report-content {
  width: calc(100% - 16px);
  // margin-bottom: 20px;
  box-sizing: border-box;
  padding: 0 16 * 2px 0 16 * 2px;
  background-color: #FFF;
  color: #222;
  z-index: 1;
  .brief-info {
    width: 100%;
    display: flex;
    align-items: center;
    // border-bottom: 1 * 2px solid #f0f0f5;
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
      .info_result {
        width: fit-content;
        margin-bottom: 29 * 2px;
        font-size: 24 * 2px;
        line-height: 34 * 2px;
        font-weight: 600;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        &.fake {
          background-size: 32 * 2px 32 * 2px;
          background-image: url("https://oss.turingsenseai.com/1628679595929512302.png");
        }
        &.real { // real
          background-size: 82px 60px;
          background-image: url("https://oss.turingsenseai.com/1628575456562452544.png");
        }
      }
      .info_desc_line {
        display: flex;
        flex-direction: column;
        margin-bottom: 15rpx;
      }
      .desc_label, .desc_content {
        font-size: 16 * 2px;
        line-height: 12* 2px;
        margin-bottom: 9 * 2px;
        &.has_cp_afterfix {
          position: relative;
          &::after {
            content: '复制';
            position: absolute;
            right: 0px;
            top: 0px;
            font-weight: 400;
            font-size: 12 * 2px;
            color: #999;
          }
        }
      }
      .desc_content_afterfix {
      }
      .desc_label {
        font-size: 12 * 2px;
        font-weight: 400;
        color: #828393;
      }
      .desc_content {
        color: #3a3d44;
        white-space: nowrap;
        font-weight: 500;
        margin-bottom: 20 * 2px;
        &.__wp {
          white-space: wrap;
          width: 280 * 2px;
          line-height: 1.2em;
          word-break: break-all;
        }
        .patch {
          font-weight: 400;
          font-size: 12 * 2px;
          margin-left: 20px;
          color: #3a94ff;
          text-decoration: underline;
        }
      }

      .score_container {
        position: absolute;
        top: 570px;
        display: flex;
        justify-content: flex-start;
        font-size: 12*2px;;
        .score_item {
          .title,.score {
            width: 60*2px;
            height: 24*2px;
            line-height: 24*2px;
            border-top: 1*2px solid #F0F0F5;
            border-right: 1*2px solid #F0F0F5;
            text-align: center;
          }
          .score {
            border-bottom: 1*2px solid #F0F0F5;
          }
        }
        .score_item:first-child {
          .title,.score {
            border-left: 1*2px solid #F0F0F5;
          }
        }
      }
    }
    .right {
      width: 135 * 2px;
      height: 126 * 2px;
      margin-left: 20 * 2px;
      margin-right: 8 * 2px;
      overflow: hidden;
      position: relative;
      top: 10 * 2px;
      right: 10 * 2px;
    }
  }

  .icon-line {
    display: inline-block;
    
    height: 19 * 2px;
    width: 297 * 2px;
    margin: 17 * 2px 0;
    background: url('https://oss.turingsenseai.com/1725609612897818121.jpg') no-repeat center;
    background-size:contain;
    background-position-x: 0;
  }

  // .picc {
  //   display: inline-block;
  //   // width: 124 * 2px;
  //   // height: 44 * 2px;
  //   height: 19 * 2px;
  //   width: 297 * 2px;
  //   margin-top: 15 * 2px;
  //   margin-bottom: 14 * 2px;
  //   margin-left: -16px;
  //   background: url('https://oss.turingsenseai.com/1661167727134266912.png') no-repeat center;
  //   background-size: cover;
  // }

  
}
.detail_container {
  margin-top: 12 * 2px;
  // display: flex;
  white-space: nowrap;
  overflow: hidden;
  z-index: 999;
  .container_scroll {
    display: inline-block;
    width: 100%;
  }
  .point_content {
    width: 100%;
    border-top: 1px solid RGB(240, 240, 245);
    .ponit_pic {
      position: relative;
      display: flex;
      align-items: center;
      margin: 20 * 2px 0;
      justify-content: center;
      &.hasFake {
        justify-content: space-between;
      }
      .picT,
      .picF {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img {
          width: 265px;
          height: 265px;
        }
      }
      .picF {
        position: relative;
        .fake_mark {
          position: absolute;
          border: 1px solid red;
          z-index: 7;
          border-radius: 45px;
          width: 9%;
          height: 8%;
        }
      }
      .pic_markT {
        position: absolute;
        top: 0;
        z-index: 6;
        width: 60%;
        height: 94%;
      }
      .pic_markF {
        position: absolute;
        top: 0;
        z-index: 6;
        height: 3.5rem;
        width: 3.5rem;
      }
      img {
        width: 35%;
        height: 35%;
        background-color: black;
        object-fit: contain;
        margin-bottom: 10px;
      }
      .trueArea {
        position: absolute;
        background-color: rgba(0, 0, 0, 0);
        object-fit: fill;
      }
      // 真
      .trueP {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .truePic {
          width: 60%;
          height: 100%;
          background-color: black;
          object-fit: contain;
          margin-bottom: 10px;
        }
      }
    }
  }
}
.safe-bottom {
  height: 150px;
}

.text111{
  font-weight: 400;
  font-size: 9 * 2px;
  // line-height: 32px;
  color: #828393;
  // background: #fff;
  margin-top: 20 * 2px;
  // padding: 30px;
  width: 343 * 2px;
}

.text111 *{
  line-height: 19 * 2px;
  font-size: 9 * 2px;
  opacity: 0.7;
}
.no-result {
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .empty {
    margin-top: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333;
  }

  .null-img {
    width: 400px;
  }
}
</style>